module.exports = __webpack_public_path__ + "img/versan_logo.cd0c71a1.png";